'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeRoomConfigValidated = {
    fromJson: fromJson,
    getRoomConfigValidated: getRoomConfigValidated,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseObject.$fromJson(data, 'RoomConfigValidated', reqProps, reqProps,
        function(data) { return getRoomConfigValidated(data.$roomId); }
    );
}

// Returns a promise that resolves to the RoomConfigValidated object when it is loaded.

function getRoomConfigValidated(roomId) {
    var key = 'RoomConfigValidated: ' + roomId;
    var config = KayleeCache.get(key);

    if (config === null) {
        config = new RoomConfigValidated(roomId);
        KayleeCache.put(key, config);
    }

    return config;
}

function RoomConfigValidated(roomId) {
    this.$nodeType = 'roomConfigValidated';
    this.$roomId = roomId;
    FirebaseObject.call(this, KayleeBase.app.database().ref('roomConfigValidated/' + roomId));
}

RoomConfigValidated.prototype = Object.create(FirebaseObject.prototype);
RoomConfigValidated.prototype.constructor = RoomConfigValidated;

RoomConfigValidated.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$roomId' ], {});
};

RoomConfigValidated.prototype.toString = function() {
    return '[RoomConfigValidated (' + this.$id + ')]';
};

module.exports = KayleeRoomConfigValidated;

